import type { OperatorProductDTO } from '@/shared/model';
import { OperatorId } from '../model/types';

const TRAVELATA_GROUP: number[] = OperatorId.Travelata;
const TRAVELATA_DISPLAY_NAME = 'Travelata';
const TRAVELATA_DISPLAY_NAME_RU = 'Травелата';

export function isTravelataOperatorId(id: number): boolean {
  return TRAVELATA_GROUP.includes(id);
}

export function normalizeOperatorNaming(operator: OperatorProductDTO): OperatorProductDTO {
  if (!isTravelataOperatorId(Number(operator.id))) return operator;
  return { ...operator, name: TRAVELATA_DISPLAY_NAME, nameRu: TRAVELATA_DISPLAY_NAME_RU };
}
